$(function () {
  function communityWelcomePageActions(){
    setCookie('X-PROGRAM', '', 365);

    $('.our-programs-btn').click(function () {
      addTagManager({
        event: 'our-programs',
        action: 'click',
        category: 'marketing',
        label: 'programs-click'
      });
    });
    $('.our-impact-btn').click(function () {
      addTagManager({
        event: 'our-impact',
        action: 'click',
        category: 'marketing',
        label: 'impact-click'
      });
    });

    $('.get-started-gtm-btn').click(function () {
      addTagManager({
        event: 'get-started',
        action: 'visit',
        category: 'account',
        label: 'hub'
      });
    })

    $('.view-data-calculation-btn').click(function () {
      $('.data-calculation-modal').modal('show');
    });

    $('section.our-impact .item').mouseover(function () {
      let windowWith = $(window).width();
      if (windowWith > 1024) {

        $('section.our-impact .item').removeClass('expanded');
        $('section.our-impact .item').removeClass('narrowed');

        $(this).addClass('expanded');
        $(this).closest('div.impact-sections').find('.item').not('.expanded').addClass('narrowed');
      }

    });

    $(window).on('resize load', function () {
      let windowWith = $(window).width();
      if (windowWith <= 1024) {
        $('.impact-container .item').addClass('expanded');
      } else {
        $('section.our-impact .item').removeClass('expanded');
        $('section.our-impact .item').removeClass('narrowed');
      }
    });
  }
  function achievementWelcomePageActions(){
    setCookie('X-PROGRAM', 'achievements-awards',365);
    $('.mob-menu-overlay nav a[href="/faq"]').attr('href','/faq?program=achievements-awards');

    $('.get-started-gtm-btn').click(function(){
      addTagManager({
        event:'get-started',
        action:'visit',
        category:'account',
        label:'paa'
      });
    })
  }
  function pslWelcomePageActions(){

    setCookie('X-PROGRAM', 'school-lunch',365);
    $('.mob-menu-overlay nav a[href="/faq"]').attr('href','/faq?program=school-lunch');

    $('.get-started-gtm-btn').click(function(){
      addTagManager({
        event:'get-started',
        action:'visit',
        category:'account',
        label:'psl'
      });
    })

    const pailQuantity = document.getElementsByName("pail-quantity")[0];
    const bowlQuantity = document.getElementsByName("bowl-quantity")[0];

    [pailQuantity, bowlQuantity].forEach(input => {
      if (input) {
        input.addEventListener('input', function () {
          if (this.value < 0) this.value = 0;
        });
      }
    });

    $('form.subscribe').validator().submit(function (e) {
      if (e.isDefaultPrevented()) return;
      let data = $(this).serializeObject();
      let gRecaptcha='';
      gRecaptcha = data.gRecaptcha;
      delete data.gRecaptcha;
      request({
        url: '/anonymous/subscriptions',
        method: 'POST',
        data: JSON.stringify(data),
        preventDefaultError: true,
        contentType : 'application/json',
        headers: {
          gRecaptcha: gRecaptcha,
        },
        callback: function (r) {
          $('form.subscribe').get(0).reset();
          gRecaptchaReset();
          Modal.show({
            type: 'success',
            html: 'Thanks for your interest in Panda community programs. You can change your subscription preferences from any mailing.',
            no: 'Close',
            withoutYes: true
          });
        },
        onError: function(r) {
          gRecaptchaReset();
          onError && onError(r && r[0] && r[0].message);
        }
      });
    });
  }
  function xlnyWelcomePageActions(){
    setCookie('X-PROGRAM', 'explore-lunar-new-year',365);
    $('.get-started-gtm-btn').click(function(){
      addTagManager({
        event:'get-started',
        action:'visit',
        category:'account',
        label:'xlny'
      });
    })
  }
  function rwmWelcomePageActions(){

    setCookie('X-PROGRAM', 'read-with-me',365);
    $('.mob-menu-overlay nav a[href="/faq"]').attr('href','/faq?program=read-with-me');

    $('.get-started-gtm-btn').click(function(){
      addTagManager({
        event:'get-started',
        action:'visit',
        category:'account',
        label:'rwm'
      });
    })
  }
  function heroesDiscountWelcomePageActions(){
    setCookie('X-PROGRAM', '', 365);
  }
  function welcomeFAQPageActions(){

    const selectedProgram = getParam('program') || "";
    if (selectedProgram === '') {
        $('.create-ticket-form .row.text-start').prepend(
          '<div class="col-md-12">' +
          '<div class="form-group labeled">' +
          '<label for="create-ticket-program" class="label-control text-secondary" >Program</label>' +
          '<select class="form-control" id="create-ticket-program" name="program"><option value="fundraiser" >Neighborhood Fundraiser</option><option value="school-lunch" >School Lunch</option><option value="virtual-fundraiser" >Virtual Community Fundraiser</option><option value="read-with-me">Read With Me</option><option value="explore-lunar-new-year">Let\'s Explore LNY</option><option value="achievements-awards">Achievement Awards</option></select>' +
          '</div>' +
          ' </div>'
        );
      $('.create-ticket-form').validator('update');
      window.xProgram = '';
    } else {
      window.xProgram = selectedProgram;
    }


    let createTicketModal = createCreateTicketModal({
      creator: 'guest',
      successMessage: true,
      outsideDialog: true,
      el: $('.create-ticket-modal-for-guest'),
      onCreate: function (ticket) {

      }
    });

    $('.contact-us-btn').click(function () {
      gRecaptchaReset();
      createTicketModal.show();
    });
    if (getParam('contact-us') === 'visible') createTicketModal.show();
  }

  if($('.community-welcome-page-container').length) {
    communityWelcomePageActions();
  }

  if($('.paa-welcome-page-container').length) {
    achievementWelcomePageActions();
  }

  if($('.psl-welcome-page-container').length) {
    pslWelcomePageActions();
  }
  
  if($('.xlny-welcome-page-container').length) {
    xlnyWelcomePageActions();
  }

  if($('.rwm-welcome-page-container').length) {
    rwmWelcomePageActions();
  }

  if($('.heroes-discount-welcome-page-container').length) {
    heroesDiscountWelcomePageActions();
  }

  if($('.welcome-faq-page-container')){
    welcomeFAQPageActions();
  }
});